import { forwardRef } from 'react';
import { useLabel } from 'react-aria';

import { useObjectRef } from '@react-aria/utils';
import { cn } from '@/lib/utils';

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, ...props }, forwardedRef) => {
    const ref = useObjectRef(forwardedRef);
    const { labelProps } = useLabel(props);

    return (
      <label
        {...labelProps}
        ref={ref}
        className={cn('block text-sm font-medium text-gray-700', className)}
        {...props}
      >
        {children}
        {/* {required && <span className='text-red-500 ml-1'>*</span>} */}
      </label>
    );
  }
);

Label.displayName = 'Label';

export { Label };
